module.exports = __webpack_public_path__ + "2443a7aef2bf02c6f24d12d0588b5a9d.png";